






















































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlClearBtn from '@/components/common/control/CtrlClearBtn.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlResetBtn from '@/components/common/control/CtrlResetBtn.vue';
import CtrlProgress from '@/components/common/control/CtrlProgress.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import G_030_JuchuToiawase_Table from '@/components/G_kaigai/G_030_JuchuToiawase_Table.vue';
import G_030_JuchuToiawase_Rireki_Table from '@/components/G_kaigai/G_030_JuchuToiawase_Rireki_Table.vue';
import G_020_JuchuEntry_ChildHeaderInput from '@/components/G_kaigai/G_020_JuchuEntry_ChildHeaderInput.vue';
import { 
  OutStatus, 
  ChohyoShurui,
  JotaiKb,
  ShoriKb,
} from '@/constants/constants';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { dateStrToNum, downloadCSVToSjis } from '@/utils/utils';
import {
  PageReport,
  FontDescriptor,
  FontStore,
} from '@grapecity/activereports/core';
import { PdfExport } from '@grapecity/activereports';
import '@/assets/scss/activeReportsJS/ar-js-ui.css';
import '@/assets/scss/activeReportsJS/ar-js-viewer.css';
import { Viewer } from '@grapecity/activereports-vue';

const headerExportCSV = [
  '出荷日',
  '納品日',
  '売上事業所コード',
  '売上事業所名',
  '売上業種コード',
  '売上NO',
  '売上行NO',
  '得意先コード',
  '得意先名',
  '納品先コード',
  '納品先名',
  '請求先コード',
  '取引先コード',
  '請求先名',
  '得意先伝票NO',
  '得意先品目コード',
  '品目コード',
  '品目名',
  '入数',
  'ケース重量',
  '売上数量',
  '端数数量',
  '売上単価',
  '歩引単価',
  '売上税抜金額',
  '消費税率',
  '消費税額',
  'オーダーNO',
  '売上日',
  '回収日',
  '請求備考',
  '明細備考',
];

function getCsvRow(item: any) {
  return [
    item.shukkaYmd,
    item.nohinYmd,
    item.uriageJigyoshoCd,
    item.uriageJigyoshoMei,
    item.uriageGyoshuCd,
    item.uriageNo,
    item.uriageGyoNo,
    item.tokuisakiCd,
    item.tokuisakiMei,
    item.nohinsakiCd,
    item.nohinsakiMei,
    item.seikyusakiCd,
    item.torihikisakiCd,
    item.seikyusakiMei,
    item.tokuisakiDenpyoNo,
    item.tokuisakiHimmokuCd,
    item.himmokuCd,
    item.himmokuMei,
    item.irisu,
    item.caseWeight,
    item.uriageSuryo,
    item.hasuSuryo,
    item.uriageTanka,
    item.bubikiTanka,
    item.uriageZeinukiKingaku,
    item.shohizeiRitsu,
    item.shohizeiGaku,
    item.orderNo,
    item.uriageYmd,
    item.kaishuYmd,
    item.seikyuBiko,
    item.meisaiBiko,
  ];
}

export default Vue.extend<any, any, any, any>({
  name: 'G_030_JuchuToiawase',
  components: {
    CtrlMessageDialog,
    CtrlDatePicker,
    CtrlResetBtn,
    CtrlClearBtn,
    CtrlProgress,
    CtrlNormalBtn,
    G_030_JuchuToiawase_Table,
    G_030_JuchuToiawase_Rireki_Table,
    G_020_JuchuEntry_ChildHeaderInput,
    Viewer,
  },
  data: () => ({
    hatchuYmdF: '',
    hatchuYmdT: '',
    shukkaYmdF: '',
    shukkaYmdT: '',
    hatchuYmd: '',
    hatchuNo: '',
    orderNo: '',
    juchuStatus: '',
    tokuisakiRyakuMei: '',
    nohinsakiMei: '',
    himmokuRyakuMei: '',
    nohinKiboYmd: '',
    tempShiryo: '',
    search: '',
    items: [],
    selected: [],
    childRirekiItem: {},
    childRirekiShow: false,
    childHeaderInputItem: {},
    childHeaderInputShow: false,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isReload: false,
    ChohyoShurui,
    chohyoShurui: -1,
    showProgress: false,
    progressValue: 0,
    progressSteps: 100,
    progressTitle: '',
    messageShowPdf: false,
    messageIdPdf: '',
    messageTextParamPdf: [],
    messageShowCsv: false,
    messageIdCsv: '',
    messageTextParamCsv: [],
    exportDialogShow: false,
  }),

  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    itemsSelected() {
      return this.selected
        .map((item: any) => ({
          hatchuYmd: dateStrToNum(item.hatchuYmd),
          hatchuNo: +item.hatchuNo,
          orderNo: +item.orderNo,
          tokuisakiMei: +item.tokuisakiMei,
          nohinsakiMei: +item.nohinsakiMei,
          himmokuMei: +item.himmokuMei,
          nohinKiboYmd: dateStrToNum(item.nohinKiboYmd),
          tempShiryo: +item.tempShiryo,
          juchuEntryJigyoshoCd: +item.juchuEntryJigyoshoCd,
          juchuEntryYmd: dateStrToNum(item.juchuEntryYmd),
          juchuNo: +item.juchuNo,
          juchuShuseiCount: +item.juchuShuseiCount,
          juchuStatus: +item.juchuStatus,
          juchuStatusMei: +item.juchuStatusMei,
        }));
    },
    disabledFlg() {
      return this.selected.length > 0
        ? false
        : true;
    },
  },

  methods: {
    async initValues() {
      //======================================
      // 初期化処理
      //======================================
      this.hatchuYmdF = moment(
        this.userInfo.onlineData.genzaiYmd.toString()
      )
        .add(-1, 'month')
        .format()
        .substr(0, 10);
      this.hatchuYmdT = this.userInfo.onlineData.genzaiYmd;
      this.shukkaYmdF = '';
      this.shukkaYmdT = '';
      this.search = '';
      this.selected = [];
      this.items = [];
      this.chohyoShurui = -1;
      this.isReload = false;
    },

    async handleReset() {
      //======================================
      // 再読込アイコンClick
      //======================================
      if (await this.checkValidate()) {        
        this.items = [];
        this.getData();
      }
    },

    handlClear() {
      //======================================
      // クリアアイコンClick
      //======================================
      this.initValues();
    },

    handleOKmessage() {
      //======================================
      // 警告メッセージOK時
      //======================================
      if (this.messageId == 'KI_W123') {
        window.location.href = '/';
      }
      if (this.isReload) {
        this.handleReset(); // 再読み込み
      }
      this.isReload = false;
      this.messageId = '';
      this.messageTextParam = [];
      this.messageShow = false;
    },

    handleRireki(item: any) {
      let rirekiItem = {
        juchuEntryJigyoshoCd: item.juchuEntryJigyoshoCd,
        juchuEntryYmd: item.juchuEntryYmd,
        juchuNo: item.juchuNo,
      };
      this.childRirekiItem = rirekiItem;
      this.childRirekiShow = true;
    },

    handleChildRirekiShowHide() {
      this.childRirekiShow = false;
      this.childRirekiItem = {};
    },

    handleRirekiInfo(item: any) {
      this.childHeaderInputItem = item;
      this.shoriKb = ShoriKb.REFER;
      this.childHeaderInputShow = true;      
    },

    handleChildHeaderInputHide(reload: boolean) {
      
    },
    
    async handleOKmessagePdf() {
      //======================================
      // PDF一括出力：確認メッセージOK時
      //======================================
      this.messageIdPdf = '';
      this.messageTextParamPdf = [];
      this.messageShowPdf = false;

      if (
        this.chohyoShurui !== ChohyoShurui.SHUKKA_ANNAISHO &&
        this.chohyoShurui !== ChohyoShurui.NOHINSHO
      ) return;

      const kbn = this.chohyoShurui;
      this.chohyoShurui = -1;

      // 対象データ絞り込み
      let taishoItems;
      if (kbn === ChohyoShurui.SHUKKA_ANNAISHO) {
        this.progressTitle = '出荷案内書ダウンロード';
        taishoItems = this.selected.filter(
          (item: any) => item.shukkaAnnaiUrl && item.shukkaAnnaiUrl.length > 0
        );
      } else {
        this.progressTitle = '納品書ダウンロード';
        taishoItems = this.selected.filter(
          (item: any) => item.nohinshoUrl && item.nohinshoUrl.length > 0
        );
      }

      // ローディング・スタート
      this.showProgress = true;
      this.progressSteps = taishoItems.length;
      this.progressValue = 0;

      for(let i=0; i<taishoItems.length; i++){
        let result = true;
        // ダウンロード処理
        if (kbn === ChohyoShurui.SHUKKA_ANNAISHO) {
            result = await this.$refs.juchuToiawaseTable.handleDownloadFiles(taishoItems[i].shukkaAnnaiUrl, kbn);
        } else {
            result = await this.$refs.juchuToiawaseTable.handleDownloadFiles(taishoItems[i].nohinshoUrl, kbn);
        }
        if (result !== true) {
          this.progressSteps = 100;
          this.progressValue = 0;
          this.showProgress = false;
          return;
        }
        this.progressValue++;
      }

      // ローディング・ストップ
      setTimeout(() => {
          this.progressSteps = 100;
          this.progressValue = 0;
          this.showProgress = false;
          // 再読込
          this.handleReset();
        }, 1000);
    },

    handleClosemessagePdf(){
      //======================================
      // PDF一括出力：確認メッセージCancel時
      //======================================
      this.messageIdPdf = '';
      this.messageTextParamPdf = [];
      this.messageShowPdf = false;
      this.chohyoShurui = -1;
    },

    async handleOKmessageCsv() {
      //======================================
      // CSV出力：確認メッセージOK時
      //======================================
      this.messageIdCsv = '';
      this.messageTextParamCsv = [];
      this.messageShowCsv = false;
      this.chohyoShurui = -1;

      // 対象データ絞り込み
      let taishoItems;
      taishoItems = this.selected.filter(
          (item: any) => item.jotaiKb == JotaiKb.URIAGE_SEISEI 
                         && item.uriageInfo && item.uriageInfo.length > 0
      );

      // ローディング表示開始
      this.$store.dispatch('common/setIsLoading', true);

      // リクエストボディ設定
      let targetList = [];
      for(let i=0; i<taishoItems.length; i++) {
        for(let n=0; n<taishoItems[i].uriageInfo.length; n++) {

          targetList.push({
            uriageEntryJigyoshoCd: taishoItems[i].uriageInfo[n].uriageEntryJigyoshoCd,
            uriageEntryYmd: taishoItems[i].uriageInfo[n].uriageEntryYmd,
            uriageNo: taishoItems[i].uriageInfo[n].uriageNo,
            uriageShuseiCount: taishoItems[i].uriageInfo[n].uriageShuseiCount,
          });
        }
      }

      // CSVデータ取得
      const requestData = { targetList } as any;
      const res = await this.$store.dispatch('g030/postCsvData', requestData);
      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.$store.dispatch('common/setIsLoading', false);
        this.isReload = true;
        this.messageId = res.data.error.messageID;
        this.messageTextParam = res.data.error.messageArgs;
        this.messageShow = true;
        return;
      }

      // CSVレイアウトマッピング
      const rows = [...[headerExportCSV]];
      res.data.responseData.map((item: any) => {
        rows.push(getCsvRow(item));
      });
        
      // ファイル名
      let fileAddStr = '';
      fileAddStr += '_' + moment(new Date()).format('YYYYMMDD_HHmmss');
      const fileName = `売上${fileAddStr}.csv`;

      // ダウンロード
      downloadCSVToSjis(rows, fileName);

      // ローディング表示終了
      this.$store.dispatch('common/setIsLoading', false);
      return;
    },

    handleClosemessageCsv(){
      //======================================
      // CSV出力：確認メッセージCancel時
      //======================================
      this.messageIdCsv = '';
      this.messageTextParamCsv = [];
      this.messageShowCsv = false;
      this.chohyoShurui = -1;
    },

    async checkValidate() {
      //======================================
      // チェック処理
      //======================================
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      if (
          !this.hatchuYmdF &&
          !this.hatchuYmdT &&
          !this.shukkaYmdF &&
          !this.shukkaYmdT
      ) {
        this.messageId = 'KI_W113';
        this.messageTextParam = ['検索条件'];
        this.messageShow = true;
        return;
      }

      if (
        this.hatchuYmdF &&
        this.hatchuYmdT &&
        dateStrToNum(this.hatchuYmdF) > dateStrToNum(this.hatchuYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['発注日'];
        this.messageShow = true;
        return;
      }
      if (
        this.shukkaYmdF &&
        this.shukkaYmdT &&
        dateStrToNum(this.shukkaYmdF) > dateStrToNum(this.shukkaYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['出荷日'];
        this.messageShow = true;
        return;
      }
      
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      return true;
    },

    async getData() {
      //======================================
      // データ取得
      //======================================
      this.selected = [];
      this.$store.dispatch('common/setIsLoading', true);
      const params = {
        jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        hatchuYmdF: this.hatchuYmdF ? dateStrToNum(this.hatchuYmdF) : 0,
        hatchuYmdT: this.hatchuYmdT ? dateStrToNum(this.hatchuYmdT) : 99999999,
        shukkaYmdF: this.shukkaYmdF ? dateStrToNum(this.shukkaYmdF) : 0,
        shukkaYmdT: this.shukkaYmdT ? dateStrToNum(this.shukkaYmdT) : 99999999,
      };
      const res = await this.$store.dispatch('g030/getData', params);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        this.messageShow = true;
        this.messageId = error.messageID;
        this.messageTextParam = error.messageArgs;
        return;
      }
      this.items = res.data.responseData
        ? res.data.responseData.map((i: any, index: number) => ({
            ...i,
            id: `${index + 1}${i.orderNo}`,
          }))
        : [];
    },

    handleIkkatsuDownload(kbn: number) {
      //======================================
      // PDF一括出力Click
      //======================================
      let taishoItems, msgText;
      if (kbn === ChohyoShurui.SHUKKA_ANNAISHO) {
        msgText = "出荷案内書";
        taishoItems = this.selected.filter(
          (item: any) => item.shukkaAnnaiUrl && item.shukkaAnnaiUrl.length > 0
        );
      } else {
        msgText = "納品書";
        taishoItems = this.selected.filter(
          (item: any) => item.nohinshoUrl && item.nohinshoUrl.length > 0
        );
      }
      if (taishoItems.length === 0) {
        this.messageId = 'KI_W125';
        this.messageTextParam = ['ダウンロード対象'];
        this.messageShow = true;
        return;
      }
      this.messageIdPdf = 'KI_Q100';
      this.messageTextParamPdf = ['選択行の' + msgText + 'をダウンロード'];
      this.messageShowPdf = true;
      this.chohyoShurui = kbn;
      return;
    },

    handleIkkatsuPreview(kbn: number) {
      //======================================
      // プレビュー一括出力Click
      //======================================
      let taishoItems;

      switch(kbn){
        case ChohyoShurui.SHUKKA_ANNAISHO:
          taishoItems = this.selected.filter(
            (item: any) => item.shukkaAnnaiUrl && item.shukkaAnnaiUrl.length > 0
          );
          break;

        case ChohyoShurui.NOHINSHO:
          taishoItems = this.selected.filter(
            (item: any) => item.nohinshoUrl && item.nohinshoUrl.length > 0
          );
          break;

        case ChohyoShurui.JUCHU_UKESHO:
          taishoItems = this.selected.filter(
            (item: any) => item.juchuUkeshoUrl && item.juchuUkeshoUrl.length > 0
          );
          break;
      }

      if (taishoItems.length === 0) {
        this.messageId = 'KI_W125';
        this.messageTextParam = ['選択行に対象データ'];
        this.messageShow = true;
        return;
      }
      
      switch(kbn){
        case ChohyoShurui.SHUKKA_ANNAISHO:
          this.handleShukkaIkkatsu();
          break;

        case ChohyoShurui.NOHINSHO:
          this.handleNohinIkkatsu();
          break;

        case ChohyoShurui.JUCHU_UKESHO:
          this.handleJuchuIkkatsu();
          break;
      }

    },

    async handleShukkaIkkatsu() {
      //======================================
      // 出荷案内書一括出力Click
      //======================================
      let taishoItems;

      taishoItems = this.selected.filter(
        (item: any) => item.shukkaAnnaiUrl && item.shukkaAnnaiUrl.length > 0
      );

      const taishoInfo : any[] = [];
      for (var i = 0; i < taishoItems.length; i++)
      {
        for (var j = 0; j < taishoItems[i].shukkaAnnaiUrl.length; j++)
        {  
          taishoInfo.push({shukkaJigyoshoCd: taishoItems[i].shukkaAnnaiUrl[j].shukkaJigyoshoCd,
                          shukkaEntryYmd: taishoItems[i].shukkaAnnaiUrl[j].shukkaEntryYmd,
                          shukkaNo: taishoItems[i].shukkaAnnaiUrl[j].shukkaNo,
                          });
        }
      }

      const payload = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          taishoInfo: taishoInfo,
        },
      };
      const data = await this.$store.dispatch(
        'g030/putShukkaAnnaiIkkatsu',
        payload
      );
      if (
        data &&
        data.status == 200 &&
        data.data &&
        data.data.error &&
        data.data.error.outStatus &&
        data.data.error.outStatus != OutStatus.NORMAL
      ) {
        // errorの場合、自画面の再検索を行わない
        this.isReloadStopFlg = true;
        this.wMessageId = data.data.error.messageID;
        this.wMessageTextParam = data.data.error.messageArgs;
        this.wMessage = true;
        return;
      }
      
      let params, result;
      for (var k = 0; k < taishoInfo.length; k++)
      {
        params = {
          shukkaJigyoshoCd: taishoInfo[k].shukkaJigyoshoCd,
          shukkaEntryYmd: taishoInfo[k].shukkaEntryYmd,
          shukkaNo: taishoInfo[k].shukkaNo,
        };
        result = await this.$store.dispatch('g030/putShukkaAnnai', params);
            
        if (
          result &&
          result.status == 200 &&
          result.data &&
          result.data.error &&
          result.data.error.outStatus &&
          result.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.messageId = result.data.error.messageID;
          this.messageTextParam = result.data.error.messageArgs;
          this.messageShow = true;
          return false;
        }
      }

      this.exportType = '出荷案内書';
      const reportResponse = await fetch(
        '/reports/N_Shu061_ShukkaAnnaisho.rdlx-json'
      );
      this.exportDialogShow = true;
      const report = await reportResponse.json();
      report.DataSources[0].ConnectionProperties.ConnectString =
        'jsondata=' + JSON.stringify(data.data.responseData.shukkaAnnaishoReportData);
      this.reportData = report;
      this.reportDataSet = await data;
      this.reportParameter = [
        { Name: 'dataString', Value: [JSON.stringify(data)] },
      ];
      if (this.$refs.reportViewer) {
        this.$refs.reportViewer
          .Viewer()
          .open(report, { ReportParams: this.reportParameter });
        // 帳票フォント定義
        const fonts: FontDescriptor[] = [
          {
            name: 'ＭＳ ゴシック',
            source: '/fonts/msgothic.ttc',
            postscriptName: 'MS-Gothic',
          },
          { name: 'IPAゴシック', source: '/fonts/ipag.ttf' },
        ];
        FontStore.registerFonts(...fonts);
      }      
    },

    async handleNohinIkkatsu() {
      //======================================
      // 納品書一括出力Click
      //======================================
      let taishoItems;
      taishoItems = this.selected.filter(
        (item: any) => item.nohinshoUrl && item.nohinshoUrl.length > 0
      );

      const taishoInfo : any[] = [];
      for (var i = 0; i < taishoItems.length; i++)
      {
        for (var j = 0; j < taishoItems[i].nohinshoUrl.length; j++)
        {  
          taishoInfo.push({uriageEntryJigyoshoCd: taishoItems[i].nohinshoUrl[j].uriageEntryJigyoshoCd,
                           uriageEntryYmd: taishoItems[i].nohinshoUrl[j].uriageEntryYmd,
                           uriageNo: taishoItems[i].nohinshoUrl[j].uriageNo,
                           uriageShuseiCount: taishoItems[i].nohinshoUrl[j].uriageShuseiCount,
                          });
        }
      }
      const payload = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          taishoInfo: taishoInfo,
        },
      };
      const data = await this.$store.dispatch(
        'g030/putNohinshoIkkatsu',
        payload
      );
      if (
        data &&
        data.status == 200 &&
        data.data &&
        data.data.error &&
        data.data.error.outStatus &&
        data.data.error.outStatus != OutStatus.NORMAL
      ) {
        // errorの場合、自画面の再検索を行わない
        this.isReloadStopFlg = true;
        this.wMessageId = data.data.error.messageID;
        this.wMessageTextParam = data.data.error.messageArgs;
        this.wMessage = true;
        return;
      }

      let params, result;
      for (var k = 0; k < taishoInfo.length; k++)
      {
        params = {
          uriageEntryJigyoshoCd: taishoInfo[k].uriageEntryJigyoshoCd,
          uriageEntryYmd: taishoInfo[k].uriageEntryYmd,
          uriageNo: taishoInfo[k].uriageNo,
          uriageShuseiCount: taishoInfo[k].uriageShuseiCount,
        };
        result = await this.$store.dispatch('g030/putNohinsho', params);
            
        if (
          result &&
          result.status == 200 &&
          result.data &&
          result.data.error &&
          result.data.error.outStatus &&
          result.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.messageId = result.data.error.messageID;
          this.messageTextParam = result.data.error.messageArgs;
          this.messageShow = true;
          return false;
        }
      }

      this.exportType = '納品書';
      const reportResponse = await fetch(
        '/reports/N_Uri031_Nohinsho.rdlx-json'
      );
      this.exportDialogShow = true;
      const report = await reportResponse.json();
      this.reportData = report;
      this.reportDataSet = await data.data.responseData;
      let reportData = `{"nohinshoData": ${JSON.stringify(
        data.data.responseData.nohinshoData
      )}}`;
      report.DataSources[0].ConnectionProperties.ConnectString =
        'jsondata=' + reportData;//JSON.stringify(reportData);
      this.reportParameter = [
        {
          Name: 'dataString',
          Value:[reportData],
        },
      ];
      if (this.$refs.reportViewer) {
        this.$refs.reportViewer
          .Viewer()
          .open(report, { ReportParams: this.reportParameter });
        // 帳票フォント定義
        const fonts: FontDescriptor[] = [
          {
            name: 'ＭＳ ゴシック',
            source: '/fonts/msgothic.ttc',
            postscriptName: 'MS-Gothic',
          },
          { name: 'IPAゴシック', source: '/fonts/ipag.ttf' },
        ];
        FontStore.registerFonts(...fonts);
      }      
    },

    async handleJuchuIkkatsu() {
      //======================================
      // 受注請書一括出力Click
      //======================================
      let taishoItems;

      taishoItems = this.selected.filter(
        (item: any) => item.juchuUkeshoUrl && item.juchuUkeshoUrl.length > 0
      );

      const taishoInfo : any[] = [];
      for (var i = 0; i < taishoItems.length; i++)
      {
        taishoInfo.push({juchuEntryJigyoshoCd: taishoItems[i].juchuEntryJigyoshoCd,
                        juchuEntryYmd: taishoItems[i].juchuEntryYmd,
                        juchuNo: taishoItems[i].juchuNo,
                        juchuShuseiCount: taishoItems[i].juchuShuseiCount,
                        });
      }

      const payload = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          taishoInfo: taishoInfo,
        },
      };

      const data = await this.$store.dispatch(
        'g030/putJuchuUkeIkkatsu',
        payload
      );

      if (
        data &&
        data.status == 200 &&
        data.data &&
        data.data.error &&
        data.data.error.outStatus &&
        data.data.error.outStatus != OutStatus.NORMAL
      ) {
        // errorの場合、自画面の再検索を行わない
        this.isReloadStopFlg = true;
        this.wMessageId = data.data.error.messageID;
        this.wMessageTextParam = data.data.error.messageArgs;
        this.wMessage = true;
        return;
      }

      let params, result;

      for (var k = 0; k < taishoInfo.length; k++)
      {
        params = {
          juchuEntryJigyoshoCd: taishoInfo[k].juchuEntryJigyoshoCd,
          juchuEntryYmd: taishoInfo[k].juchuEntryYmd,
          juchuNo: taishoInfo[k].juchuNo,
          juchuShuseiCount: taishoInfo[k].juchuShuseiCount,
        };

        result = await this.$store.dispatch('g030/putJuchuUke', params);
            
        if (
          result &&
          result.status == 200 &&
          result.data &&
          result.data.error &&
          result.data.error.outStatus &&
          result.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.messageId = result.data.error.messageID;
          this.messageTextParam = result.data.error.messageArgs;
          this.messageShow = true;
          return false;
        }
      }

      this.exportType = '受注請';
      const reportResponse = await fetch(
        '/reports/N_Juc051_Juchuukesho.rdlx-json'
      );
      this.exportDialogShow = true;
      const report = await reportResponse.json();
      this.reportData = report;
      this.reportDataSet = await data.data.responseData;
      let reportData = `${JSON.stringify(
        data.data.responseData.juchuUkeReportData
      )}`;
      report.DataSources[0].ConnectionProperties.ConnectString =
        'jsondata=' + reportData;//JSON.stringify(reportData);
      this.reportParameter = [
        {
          Name: 'dataString',
          Value:[reportData],
        },
      ];
      if (this.$refs.reportViewer) {
        this.$refs.reportViewer
          .Viewer()
          .open(report, { ReportParams: this.reportParameter });
        // 帳票フォント定義
        const fonts: FontDescriptor[] = [
          {
            name: 'ＭＳ ゴシック',
            source: '/fonts/msgothic.ttc',
            postscriptName: 'MS-Gothic',
          },
          { name: 'IPAゴシック', source: '/fonts/ipag.ttf' },
        ];
        FontStore.registerFonts(...fonts);
      }      
    },

    async exportDialogClose() {
      //======================================
      // プレビュー画面Close
      //======================================

      // ローディング・ストップ
      setTimeout(() => {
          this.progressSteps = 100;
          this.progressValue = 0;
          this.showProgress = false;
          // 再読込
          this.handleReset();
        }, 1000);
      
      this.exportDialogShow = false;

    },

    async exportOrder() {
      //======================================
      // PDFダウンロードClick
      //======================================
      const date = new Date();
      const dateNow = date.getFullYear()
                      + ('00' + (date.getMonth() + 1) ).slice(-2)
                      + ('00' + date.getDate()).slice(-2)
                      + '_'
                      + ('00' + date.getHours()).slice(-2)
                      + ('00' + date.getMinutes()).slice(-2)
                      + ('00' + date.getSeconds()).slice(-2);
      const title =
        this.exportType === '出荷案内書'
          ? '出荷案内書_' + dateNow
          : this.exportType === '納品書'
          ? '納品書_' + dateNow
          : '';
      const fileName = title;

      if (!title && !fileName) {
        console.log('不明なデータ');
        return;
      }

      const newReport = new PageReport({ language: 'jp' });
      const data = await this.reportDataSet;
      const doc = await newReport.load(this.reportData).then(() => {
        newReport.parameters['dataString'].values = [JSON.stringify(data)];
        return newReport.run();
      });
      PdfExport.exportDocument(doc, {
        info: {
          title,
        },
      })
        .then((result) => {
          result.download(fileName);
        })
        .catch(console.error);
    },

    handleCsvDownload() {
      //======================================
      // CSVダウンロードClick
      //======================================
      let taishoItems;
      taishoItems = this.selected.filter(
        (item: any) => item.jotaiKb == JotaiKb.URIAGE_SEISEI
                       && item.uriageInfo && item.uriageInfo.length > 0
      );

      if (taishoItems.length === 0) {
        this.messageId = 'KI_W125';
        this.messageTextParam = ['選択行に対象データ'];
        this.messageShow = true;
        return;
      }
      this.messageIdCsv = 'KI_Q103';
      this.messageTextParamCsv = ['CSVダウンロードします（売上）',''];
      this.messageShowCsv = true;
      return;
    },
  },

  created() {
    if (!this.userInfo.riyoshaTokuisakiData) {
      this.messageId = 'KI_W123';
      this.messageTextParam = ['利用者得意先マスタの得意先が未設定の', '実行'];
      this.messageShow = true;
      return;
    }
    this.initValues();
  },
});
